module.exports = __webpack_public_path__ + "static/media/cp.e384076f.png";